import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { DomSanitizerModule } from '@epicuro-next/ataraxia/dom-sanitizer';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { DataMerchandiseModule } from '@epicuro-next/data/merchandise';
import { SessionStateModule } from '@epicuro-next/state/session-state';

import { FooterComponent } from './footer.component';

@NgModule({
  imports: [
    CommonModule,
    AccordionModule,
    RouterModule,
    IconsModule,
    SessionStateModule,
    DataMerchandiseModule,
    DomSanitizerModule,
  ],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
